<template>
  <v-container>
    <v-card color="">
      <v-card-title style="color: #B08836"  class="font-weight-bold">
        <h2 class="heading font-weight-bold">Enviar Documento para el Toca 123/2024</h2>
        <v-spacer></v-spacer>
        <v-btn color="#0A4A79" dark to="/tocas/list" small>
          <v-icon small class="mr-5">mdi-arrow-left</v-icon>
          Ir a Panel
        </v-btn>
      </v-card-title>
      <v-divider inset></v-divider>
      <v-card-text>
        <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="8" md="8">
              <v-autocomplete
                v-model="escritosSelected"
                :items="escritoList"
                dense
                item-text="nombre"
                item-value="id"
                return-object
                label="Selecciona tipo de documento"
                prepend-icon="mdi-gavel"
                outlined
                @change="cleanSalaSelected()"
                persistent-hint
                no-data-text="No se Encontraron tipo de documento"
                required
                :rules="[v => !!v|| 'Seleccione el tipo de documento']"
              ></v-autocomplete>
              
            </v-col>

          </v-row>
          <v-row class="mt-n7">
            <v-col cols="8" sm="8">
              <v-text-field
                  dense
                  v-model.trim="leyenda"
                  label="Leyenda"
                  prepend-icon="mdi-message-text"
                  outlined
                  required
                  :rules="[v => !!v|| 'Este campo es requerido']"
                ></v-text-field>
            </v-col>
            <v-col cols="2" sm="2" class="mt-2">    
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-information
                  </v-icon>
                </template>
                <span style="font-size: large;">Ejemplo: Envío de promoción para solicitar copia certificada.</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <!-- <v-row class="mt-n7">
            
            <v-col v-if="escritosSelected == '' " cols="12" sm="5">
              <v-text-field
              outlined
              dense
              v-model="toca"
              label="Número de Toca"
              prepend-icon="mdi-folder"
              min='1'
              placeholder="1234/2021"
              :rules="tocaRules"
              >
              </v-text-field>
            </v-col>
            <v-col v-if="salaSelected.id == 12" cols="12" md="5">
              <v-text-field
                dense
                v-model.trim="expediente"
                label="Asunto Laboral"
                prepend-icon="mdi-folder"
                outlined
                required
                placeholder="1234/2021"
                :rules="expedienteRules"
              ></v-text-field>
            </v-col>
            <v-col v-if="salaSelected.id == 13" cols="12" md="12">
              <v-text-field
                dense
                v-model.trim="asunto"
                label="Asunto"
                prepend-icon="mdi-message-text"
                outlined
                required
                :rules="[v => !!v|| 'Este campo es requerido']"
              ></v-text-field>
            </v-col>
          </v-row> -->
          </v-form>
          <!-- Fin form crear -->

          <v-row>
            <v-col class="" align="center">
               <h3>BAJO PROTESTA DE DECIR VERDAD, ADJUNTO LOS SIGUIENTES DOCUMENTOS</h3>
            </v-col>
          </v-row><br>

          <!-- form firmar documento -->
          <v-form @submit.prevent="save" ref="evidencia" v-model="validEvidencia" lazy-validation>
          <v-card>
            <!-- <v-row >
              <v-col align="center">
                 <h3>BAJO PROTESTA DE DECIR VERDAD, ADJUNTO LOS SIGUIENTES DOCUMENTOS</h3>
              </v-col>
            </v-row> -->
            <v-row class="mt-n1 ml-5">
              <v-col cols="12">
                <p class="font-weight-black" align="">Firmar Documento</p>
              </v-col>
            </v-row>

            <v-row v-if="salaSelected.id <= 11" class="mt-n5">
              <v-col cols="12"  align="center">
                <span class="font-weight-bold">Subir el escrito de la promoción</span>
              </v-col>
            </v-row>

            <v-row v-if="salaSelected.id == 12" class="mt-n5">
              <v-col cols="12"  align="center">
                <span class="font-weight-bold">Subir el Asunto Laboral</span>
              </v-col>
            </v-row>

            <v-row v-if="salaSelected.id == 13" class="mt-n5">
              <v-col cols="12"  align="center">
                <span class="font-weight-bold">Subir el Documento</span>
              </v-col>
            </v-row>

            <v-row justify="center" class="mt-n5 mr-9">
              <v-col cols="12" align="center">
                <v-file-input
                  v-model="file_promocion"
                  color="blue darken-2"
                  :label="salaSelected.id <= 11 ? 'Selecciona Promoción' : 'Selecciona Documento'"
                  prepend-icon="mdi-paperclip"
                  outlined
                  dense
                  show-size
                  :clearable="false"
                  accept="application/pdf, .doc, .docx"
                  truncate-length="50"
                  :rules="fileRules"
                  @change="SelccionarArchivo($event)"
                  :disabled="archivo.encode != ''"
                ></v-file-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-row class="mt-n6">
                  <v-col cols="12">
                    <p class="font-weight-black" align="center">Firma Firel</p>
                  </v-col>
                </v-row>

                <v-row class="mt-n6 ml-7">
                  <v-col  md="12" align="">
                    <v-file-input
                      v-model="file_firel"
                      color="blue darken-2"
                      label="Seleccionar la firel"
                      prepend-icon="mdi-certificate"
                      outlined
                      dense
                      show-size
                      accept=".pfx"
                      @change="SeleccionarPfx($event)"
                      truncate-length="50"
                      :disabled="archivo.encode != ''"
                    ></v-file-input>
                  </v-col>
                </v-row>

                <v-row class="mt-n6 ml-7">
                  <v-col cols="12">
                    <v-text-field outlined dense
                      v-model="password"
                      label="Contraseña"
                      type="text"
                      prepend-icon="mdi-lock-outline"
                      :type="showpass ? 'text' : 'password'"
                      :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showpass = !showpass"
                      truncate-length="50"
                      :disabled="archivo.encode != ''"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-n6 ml-15">
                  <v-col cols="2">
                    <v-btn
                      :loading="loadingFirma"
                      v-model="activarBoton"
                      @click="firmar()"
                      :disabled="!activarBoton || file_promocion.size > 20971520"
                      color="primary">FIRMAR FIREL
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                <v-col v-if="archivo.file_name" class="ml-6">
                  <ul>
                    <li>
                      <span><b>Promoción Firmada:</b>
                        {{ archivo.file_name }}
                        <v-icon
                         color="green"
                       >mdi-check</v-icon>&nbsp;
                       <v-btn
                         x-small
                         @click="saveTextAsFile()"
                         color="primary">Ver Evidencia
                       </v-btn>&nbsp;
                     </span>

                    </li>
                  </ul>
                </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="6">
                <v-row class="mt-n6">
                  <v-col cols="12">
                    <p class="font-weight-black" align="center">Firma eFirma</p>
                  </v-col>
                </v-row>
                <v-row class="mt-n6">
                  <v-col md="11">
                    <v-file-input
                      v-model="key"
                      color="blue darken-2"
                      label="Ingrese archivo .key"
                      prepend-icon="mdi-key"
                      outlined
                      dense
                      accept=".key"
                      truncate-length="50"
                      @change="SeleccionarKey($event)"
                      :disabled="archivo.encode != ''"
                    ></v-file-input>
                  </v-col>
                </v-row>
                <v-row class="mt-n6">
                  <v-col md="11">
                    <v-file-input
                      v-model="cert"
                      color="blue darken-2"
                      label="Ingrese archivo .cer"
                      prepend-icon="mdi-certificate"
                      outlined
                      dense
                      accept=".cer"
                      truncate-length="50"
                      @change="SeleccionarCer($event)"
                      :disabled="archivo.encode != ''"
                    ></v-file-input>
                  </v-col>
                </v-row>

                <v-row class="mt-n6">
                  <v-col cols="11">
                    <v-text-field outlined dense
                      v-model="password2"
                      label="Contraseña"
                      type="text"
                      prepend-icon="mdi-lock-outline"
                      :type="showpass2 ? 'text' : 'password'"
                      :append-icon="showpass2 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showpass2 = !showpass2"
                      truncate-length="50"
                      :disabled="archivo.encode != ''"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-n6 ml-6">
                  <v-col cols="2">
                    <v-btn
                      :loading="loadingeFirma"
                      v-model="activarBoton2"
                      :disabled="!activarBoton2 || file_promocion.size > 20971520"
                      @click="firmarSat()"
                      color="primary">FIRMAR eFIRMA
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

          </v-card><br><br>
          </v-form>
          <!-- fin form firmar documento -->

          <!-- form agregar documentos anexos -->
          <v-form @submit.prevent="save" ref="archivos" v-model="validArchivos" lazy-validation>
          <v-card v-if="salaSelected.id <= 11">
          <v-row class="mt-n2">
            <v-col cols="12">
              <p class="font-weight-black" align="center">Anexar Documentos</p>
            </v-col>
          </v-row>
          <v-row class="mt-n7">
            <!-- <v-col cols="12" md="5">
              <v-text-field
                v-model="nombre_documento"
                dense
                outlined
                class="mb-n4"
                label="Nombre Documento"
              >
              </v-text-field>
            </v-col> -->
            <v-col cols="12" md="7">
              <v-file-input
                v-model="files"
                color="blue darken-2"
                label="Seleccionar Archivo PDF"
                prepend-icon="mdi-paperclip"
                outlined
                dense
                show-size
                truncate-length="50"
                :rules="fileRules"
                accept="application/pdf"
              ></v-file-input>
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                v-model="tipo_documento"
                :items="ListTipoDocumento"
                item-text="nombre"
                return-object
                label="Tipo de Documento"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col cols="2">
              <v-btn depressed color="primary" @click="fileSelected(files, 1)" :disabled="validateDocumento">AGREGAR</v-btn>
            </v-col>
          </v-row><br>

          <v-row class="mt-n6 ml-7">
            <v-col cols="12" v-if="documentos.length >=1 ">
              <p class="font-weight-black" align="left">Documentos Anexados</p>
            </v-col>
            <v-col class="mt-n7">
              <ul>
                <li v-for="item in documentos">
                  {{ item.file_name }} - {{item.tipo_documento_nombre}}
                   <v-icon
                    color="red"
                    @click="removeItem(item)"
                  >mdi-close</v-icon>
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-card><br>
        </v-form>
        <!-- fin form documentos anexos -->

          <v-row v-if="salaSelected.id <= 11">
            <v-col cols="12" align="right">
              <v-btn
                tile
                color="success"
                :loading="loading"
                :disabled="!valid"
                @click="validate"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Enviar Promoción
              </v-btn>
            </v-col>
          </v-row>

          <v-row class="mt-n9" v-if="salaSelected.id == 12">
            <v-col cols="12" align="right">
              <v-btn
                tile
                color="success"
                :loading="loading"
                :disabled="!valid"
                @click="validate"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Enviar Asunto
              </v-btn>
            </v-col>
          </v-row>

          <v-row class="mt-n9" v-if="salaSelected.id == 13">
            <v-col cols="12" align="right">
              <v-btn
                tile
                color="success"
                :loading="loading"
                :disabled="!valid"
                @click="validate"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Enviar Documento
              </v-btn>
            </v-col>
          </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {SelectFileSign,message,SelectPfx,OpenPfx,PKCS7creado,extFileUpload} from '@/services/cliente';
import {SelectFileSigneFirma, SelectKEY, SelectCER, validateKeyPairs, FirmarEfirma, messageeFirma, PKCS7creadoeFirma, extFileUploadeFirma } from '@/services/eFirma';
import { CertificateRequest } from '@/services/clasesFirma';
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";
  export default {
    data(){
      return {
        pkcs7:'',
        dialogPdf: false,
        activarBoton: false,
        activarBoton2: false,
        filePFXselct: false,
        fileKEYselct: false,
        fileCERselct: false,
        message:'',
        messageeFirma:'',
        extArchivoCargado:'',
        extArchivoCargadoeFirma:'',
        file_firel: [],
        password:'',
        password2:'',
        showpass: false,
        showpass2: false,
        loading: false,
        loadingFirma: false,
        loadingeFirma: false,
        valid: true,
        validEvidencia: true,
        validArchivos: true,
        toca:'',
        expediente:'',
        asunto:'',
        numero:'',
        derivado:'',
        periodo:'',
        municipioSelected:'',
        salaSelected:[],
        escritosSelected:'',
        descripcion: '',
        abogado_id: '',
        salasList:[],
        escritoList:[{id:'1', nombre:'Oficio'}, {id:'2', nombre:'Promoción'}],
        file_promocion:[],
        filesPromocion:[],
        nombre_documento:'',
        tipo_documento:'',
        titulo:'',
        files:[],
        documentos:[],
        archivo:{
          encode:'',
          type:'application/pdf',
          file_name:'',
          size:''
        },
        creaevidencia:true,
        sign:false,
        user:'',
        key:[],
        cert:[],
        password:'',
        validateDocumento: true,
        tocaRules: [
          v => !!v.trim().length || 'Ingrese el Número de Toca',
          v => /^(\d+)(\/)(\d{4})(-[A-Z]*)*$/.test(v) || 'Ingrese formato valido',
        ],
        expedienteRules: [
          v => !!v|| 'Ingrese el Número de Asunto Laboral',
          v => /^(\d+)(\/)(\d{4})(-[A-Z]*)*$/.test(v) || 'Ingrese formato valido'
        ],
        // numberRules: [v => !!v || 'Este campo es requerido',
        //               v => /^([1-9][0-9]*)*$/.test(v)  || 'El Toca no debe iniciar con cero'],
        // periodoRules: [
        //                v => ( v >= 1900 ) || 'El año no puede ser menor  al año 1900',
        //                v => ( v <= new Date().getFullYear() ) || 'El año no puede ser mayor al año actual',
        //               ],
        fileRules: [
          value => !value || value.size < 20971520 || 'El documento no debe exceder de 20MB!',
          // v => !v || 'El Campo es Requerido',
        ],
        ListTipoDocumento: [{id :'1', nombre:'Original'},{id :'2', nombre:'Copia Simple'}, {id :'3', nombre:'Copia Certificada'}],
      }
    },
    computed: {
      formTitle () {
        // if (this.salaSelected.id === 12) {
        //   return 'Nuevo Asunto Laboral'
        // }else if (this.salaSelected.id === 13) {
        //   return 'Buzón Presidencia'
        // }
        return 'Firma Documento'
      },
      ...mapGetters([
        "currentUser",
        "listSalas",
        "roleUser",
        // "listMunicipios"
      ]),
    },
    watch: {
      files: function (val) {
        if(val && (!this.tipo_documento || val.size > 20971520)){
          this.validateDocumento = true
        }
        else if (!val) {
          this.validateDocumento = true
        }
        else {
          this.validateDocumento = false
        }
      },
      tipo_documento: function (val) {
        if(val && (!this.files || !this.files.name || this.files.size > 20971520)){
          this.validateDocumento = true
        }
        else if (!val) {
          this.validateDocumento = true
        }
        else {
          this.validateDocumento = false
        }
      },
    },
    mounted() {
      // this.getMunicipios();
      // this.getSalas();
    },
    methods:{
      //Metodos Firel
      SelccionarArchivo(file) {
        
        if(file === undefined){
           this.activarBoton = false;
           this.activarBoton2 = false;
          return false;  
        }
          SelectFileSign(file).then((isValidFile)=>{
          if(isValidFile){
                this.message=message;
                this.extArchivoCargado=extFileUpload;
                if(this.filePFXselct != ""){
                   this.activarBoton = true;
                }
                 
                if(this.fileKEYselct != ''){
                   this.activarBoton2 = true;
                   SelectCER(this.cert);
                }
            }
         });

         SelectFileSigneFirma(file).then((isValidFile) => {
         
              if (isValidFile) {
                  this.messageeFirma = messageeFirma;
                  this.extArchivoCargadoeFirma = extFileUploadeFirma;
                  
              }
              
          });
      },
      SeleccionarPfx(filePFX) {
        if(filePFX === null){
          this.filePFXselct = '';
          this.activarBoton =false;
          return false;
        }
        this.filePFXselct=filePFX;
        this.activarBoton=SelectPfx(filePFX);
        // if(this.activarBoton){
        //     this.filePFXselct=filePFX;
        // }
      },
      firmar() {
        OpenPfx(this.filePFXselct,this.password).then((isCreatePKCS7)=>{
            if(isCreatePKCS7){
                var fecha = new Date();
                this.pkcs7=PKCS7creado;
                this.FileName = "pkcs7_" + fecha.valueOf() + "." + this.extArchivoCargado;
                this.creaEvidencia(this.pkcs7);
            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Archivo PFX o contraseña invalida, Favor de Verificar',
                confirmButtonText: "Aceptar",
              })
            }
         });
      },

      // metodos eFIRMA
      SeleccionarKey(filePFX) {
        
        if (SelectKEY(filePFX)) {
              this.fileKEYselct = filePFX;
                 if(this.message != '' && this.fileCERselct != false){
                         this.activarBoton2 = true;
                         }
          }else{
             this.fileKEYselct = "";
             this.activarBoton2 = false;
          }
      },
      SeleccionarCer(fileCER) {
        
        if(fileCER === null){
          this.activarBoton2 = false;
          return false;
        }

          this.fileCERselct = fileCER;
               
          if(this.message != ''){
             this.activarBoton2 = true;
             SelectCER(fileCER);
             
          }else{
            this.activarBoton2 = false;
          }
          
          
          // SelectCER(fileCER).then((isValidFile) => {
            // this.activarBoton2=SelectCER(fileCER);
            // if (this.activarBoton2) {
            //       this.fileCERselct = fileCER;
            // }
          // });
      },

      firmarSat() {
          if (this.password2) {
              //Validacion de llaves
              let validacion = false;
              let privateKeyPem = '';
              validateKeyPairs(this.password2, function (e) {

                  if (e.state == 0) {
                      validacion = true;
                      privateKeyPem = e.privateKey;
                  }
                  else {
                    Swal.fire({
                      icon: 'warning',
                      title: e.description,
                      confirmButtonText: "Aceptar",
                    })
                      // alert(e.description);
                      validacion = false;
                  }
              });
              if (validacion) {
                  FirmarEfirma(privateKeyPem).then((isCreatePKCS7) => {
                      if (isCreatePKCS7) {
                          var fecha = new Date();
                          this.pkcs7 = PKCS7creadoeFirma;
                          this.FileName = "pkcs7_" + fecha.valueOf() + "." + this.extArchivoCargadoeFirma;
                          this.creaEvidencia(this.pkcs7);
                      }
                  });
              }
              else { this.password = ""; }
          }
          else {
            Swal.fire({
              icon: 'warning',
              title: 'Ingrese su contraseña de clave privada.',
              confirmButtonText: "Aceptar",
            })
              // alert("Ingrese su contraseña de clave privada.");
          }
      },

      creaEvidencia(pkcs7)
      {
          Swal.fire({
            title: 'Estableciendo comunicación',
            html: 'Generando Evidencia Criptográfica ...',
            allowOutsideClick: false,
            showConfirmButton: false,
            onBeforeOpen: () => {
              Swal.showLoading()
            },
          })
        this.creaevidencia=true;
        this.loadingFirma = true;
        this.loadingeFirma = true;
        // let archivos = this.pkcs7.nativeElement.files;
        if(pkcs7){
           CertificateRequest.CertificateType = 3;
           CertificateRequest.Pkcs7Original = this.pkcs7;
           CertificateRequest.FileName = this.FileName;
           CertificateRequest.UserName = "Eliminar";
           this.$store.dispatch("FIREL_FIRMA", { url: "efirma/firmar", data: CertificateRequest })
           .then(response => {
             Swal.close();
              console.log(response.data);
             this.loadingFirma = false;
             this.loadingeFirma = false;
            //  if(!response.data.data.IsSuccess){
            //         Swal.fire({
            //          icon: 'error',
            //          title: response.data.data.ErrorMessage,
            //          confirmButtonText: "Aceptar",
            //         //  timer: 4500,
            //        })
            //     return false;
            //    }

            
             Swal.fire({
               icon: 'success',
               title: 'Promoción Firmada con Éxito',
               confirmButtonText: "Aceptar",
               timer: 1500,
             })
              this.archivo.encode = response.data.data.PdfBase64;
             var fecha = new Date();
             this.archivo.file_name = "evidencia_" + fecha.valueOf();
             this.sign = true;
             this.key = [];
             this.cert = [];
             this.file_firel = [];
             this.file_promocion = [];
             this.password = '';
             this.password2 = '';
             this.activarBoton = false;
             this.activarBoton2 = false;
             this.$refs.evidencia.resetValidation()
                        
           })
           .catch(err => {
             console.log(err);
             this.loadingeFirma = false;
             this.loadingFirma = false;
           });
        } else {
          this.creaevidencia=false;
        }
      },

      // getMunicipios() {
      //   this.$store.dispatch("GET_MUNICIPIOS",  { url: "/municipios" } ).then(response => {
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
      // },

      getSalas() {
        this.salaSelected = ''
        this.$store.dispatch("GET_SALAS",  { url: "/salas",
        }).then(response => {
          // console.log(response.data);
          this.salasList = response.data.data.salas
        })
        .catch(err => {
          console.log(err);
        });
      },

      cleanSalaSelected() {
        if (this.salaSelected.id > 11) {
          this.toca = ''
        }
        if (this.salaSelected.id == 12) {
          this.asunto = ''
          this.$refs.form.resetValidation()
        }
        if (this.salaSelected.id == 13) {
          this.expediente = ''
          this.$refs.form.resetValidation()
        }
      },

      validate() {
        if (!this.$refs.form.validate()) {
          Swal.fire({
            icon: 'warning',
            title: 'Favor de verificar los campos Requeridos',
            confirmButtonText: "Aceptar",
          })
        }
        else if (!this.sign) {
          Swal.fire({
            icon: 'warning',
            title: 'Favor de Firmar Promoción',
            confirmButtonText: "Aceptar",
          })
        }
        // if (!this.documentos.length) {
        //   this.loading = false
        //   Swal.fire({
        //     icon: 'error',
        //     title: 'Favor de agregar documentos.',
        //   })
        //   return false;
        // }
        if (this.$refs.form.validate() && this.sign == true) { // producción
        // if (this.$refs.form.validate() && this.sign == false) { // pruebas
          this.loading = true
          if (this.salaSelected.id == 12) {
            this.saveExpediente()
          } else if (this.salaSelected.id == 13) {
            this.saveBuzon()
          } else {
            this.save()
          }
        }
      },

      saveExpediente() {
        var expediente = this.expediente
          expediente = expediente.split("/",3)
          this.numero = expediente[0];
          this.periodo = expediente[1];
          this.derivado = expediente[2];
        const escrito = {
          sala_id: this.salaSelected.id,
          numero: this.numero,
          periodo: this.periodo,
          derivado: this.derivado,
          abogado_id: this.currentUser.id,
          firma_id:'udhqiufqwuifjdj',
          expediente_file: this.archivo
        }
        this.$store.dispatch("SAVE_INITIAL_EXPEDIENTE",  { url: "/expediente", data: escrito } ).then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Asunto Enviado',
            confirmButtonText: "Aceptar",
            timer: 1500,
          })
          this.$router.push('/panel')
        })
          .catch(err => {
            Swal.fire({
                icon: 'error',
                title: err.response.data.message,
              })
            this.loading = false
            console.log("el error de nuevo",err);
          });
      },

      saveBuzon() {
        const buzon = {
          sala_id: this.salaSelected.id,
          asunto: this.asunto,
          abogado_id: this.currentUser.id,
          firma_id:'udhqiufqwuifjdj',
          buzon_file: this.archivo
        }
        this.$store.dispatch("SAVE_INITIAL_BUZON",  { url: "/buzon", data: buzon } ).then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Escrito Enviado',
            confirmButtonText: "Aceptar",
            timer: 1500,
          })
          this.$router.push('/panel')
        })
          .catch(err => {
            Swal.fire({
                icon: 'error',
                title: err.response.data.message,
              })
            this.loading = false
            console.log("el error de nuevo",err);
          });
      },

      save() {
        var toca = this.toca
          toca = toca.split("/",3)
          this.numero = toca[0];
          this.periodo = toca[1];
          this.derivado = toca[2];
        const promocion = {
          tipo:2,
          //solicitud_escrita: this.descripcion,
          sala_id: this.salaSelected.id,
          titulo:this.titulo,
          numero: this.numero,
          periodo: this.periodo,
          derivado: this.derivado,
          abogado_id: this.currentUser.id,
          firma_id:'huwgduiqgduyqwgd',
          files: this.documentos,
          promocion_file: this.archivo
        }
        this.$store.dispatch("SAVE_INITIAL_PROMOCION",  { url: "/promocion", data: promocion } ).then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Promoción Enviada',
            confirmButtonText: "Aceptar",
            timer: 1500,
          })
          this.$router.push('/panel')
        })
          .catch(err => {
            Swal.fire({
                icon: 'error',
                title: err.response.data.message,
              })
            this.loading = false
            console.log("el error de nuevo",err);
          });
      },

      fileSelected(item, firma){
        var file = item;
        // if (firma == 2) {
        //   this.nombre_documento = "Promoción"
        //   // var url = "https://e-firma.stjjalisco.gob.mx/(S(sgj2pok3qcijclcysys53xjy))/Home/InicioSesion"
        //   // window.open(url, '_blank');
        // }
        this.getBase64(file).then(data => {
          var block = data.split(";");
          var realData = block[1].split(",")[1];
          this.documentos.push({
            titulo:this.titulo,
            nombre: this.nombre_documento,
            tipo_documento_nombre: this.tipo_documento.nombre,
            tipo_documento: this.tipo_documento.id,
            sign: firma,
            type: 'application/pdf',
            file_name: file.name.split(".pdf")[0],
            size: file.size,
            encode: realData
          });
          this.files = null
          this.nombre_documento = ''
          this.tipo_documento = ''
        });
      },
      // filePromocion(item,firma){
      //     // var url = "https://e-firma.stjjalisco.gob.mx/(S(sgj2pok3qcijclcysys53xjy))/Home/InicioSesion"
      //     // window.open(url, '_blank');
      //   this.sign = true;
      //   var file = this.file_promocion;
      //   this.getBase64(file).then(data => {
      //     this.filesPromocion.push(data);
      //     // console.log(data);
      //     this.FilesToUpload()
      //   });
      //   // Swal.fire({
      //   //   icon: 'success',
      //   //   title: 'Promoción Firmada',
      //   //   confirmButtonText: "Aceptar",
      //   //   timer: 1500,
      //   // })
      // },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
          }
        });
      },

      saveTextAsFile() {
        var fileB64 = this.archivo.encode
        var fecha = new Date();
        let blob = this.b64toBlob(fileB64, 'application/pdf', 512);
        let fileNameToSaveAs = "evidencia_" + fecha.valueOf() + ".pdf";
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('target' ,'_blank');
        // link.setAttribute('download', fileNameToSaveAs);
        document.body.appendChild(link);
        link.click();
      },

      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },
      // FilesToUpload() {
      //   if (this.filesPromocion.length) {
      //     this.filesPromocion.forEach(file => {
      //       var block = file.split(";");
      //       // Get the content type of the image
      //       var contentType = block[0].split(":")[1]; // In this case "jpg
      //       // get the real base64 content of the file
      //       this.archivo['type'] = contentType
      //       var realData = block[1].split(",")[1];
      //       // console.log(realData);
      //       this.archivo['encode'] = realData
      //       this.archivo['file_name'] = this.file_promocion.name.split(".pdf")[0];
      //       // console.log(this.archivo);
      //     });
      //   }
      // },
      removeItem(item){
        // if (item.sign==2) this.file_promocion = null
        this.documentos.splice(this.documentos.indexOf(item), 1);
      },
    }
  }
</script>
